export default __webpack_public_path__ + "static/media/sites7.f40037e8.png";